module.exports = __webpack_public_path__ + "static/img/4.1e0a12e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testimages/4.png
// module id = v75J
// module chunks = 1